export const dateISOFormatter = (date) => {
    const dateArray = date.toString().split(" ");
    const monthStr = (date.getMonth() + 1).toString();
    const month = monthStr.length == 1 ? "0" + monthStr : monthStr;
    return dateArray[3] + "-" + month + "-" + dateArray[2] + "T" + dateArray[4];
};
